import { type ThemeOptions } from '@mui/material';

export function createPaginationStyles() {
  return {
    MuiPaginationItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focusVisible': {
            '&::after': {
              borderRadius: `${theme.ui.focus.borderRadius}`,
              content: '""',
              display: 'block',
              inset: 0,
              outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
              outlineOffset: `${theme.ui.focus.outlineOffset}`,
              position: 'absolute',
            },
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
